import React from 'react';
import styled from '@emotion/styled';
import styleVars from '../design-system/scss-vars';
import { mediaBreakpointUpMD } from '../constants/style-constants';

// These are deliberately not ordered as they render in two columns :-/
// 1  4
// 2  5
// 3
const links = [
  { label: '01. Scores', url: '/my-account/scores' },
  { label: '04. Careers', url: '/my-account/careers' },
  { label: '02. Attributes', url: '/my-account/attributes' },
  { label: '05. Stories', url: '/my-account/stories' },
  { label: '03. Spy Role', url: '/my-account/spy_role' },
];

const Root = styled.div`
  border-bottom: 1px solid #343434;
  background: ${styleVars.ssDark};
  padding: 15px 25px;

  ${mediaBreakpointUpMD} {
    display: none;
  }
`;

const Link = styled.a`
  display: inline-block;
  color: ${({ active }) => (active ? styleVars.ssPrimary : styleVars.ssBright)};
  font-size: 14px;
  font-family: ${styleVars.ssFontFam};
  min-width: 50%;
  margin: 8px 0;
  text-transform: uppercase;
`;

export default () => (
  <Root>
    {links.map(({ label, url }) => {
      const active = window.location.pathname.includes(url);

      return (
        <Link key={url} active={active} href={url}>
          {label}
        </Link>
      );
    })}
  </Root>
);
